<template>
  <Container>
    <TableBody :content="content" :titles="titles" :filters="filters" />
  </Container>
</template>

<script>
import TableBody from './overviewTableBody.component';
import { Container } from './overviewTable.styles';
import { flatten, groupBy, last, map, pathOr, pipe, prop, sortBy, toPairs } from 'ramda';
import { mapGetters } from 'vuex';
import { PREFIX as REGIONS_STORE } from '../../../modules/regions';
import { GET_SELECTED_FILTERS, GET_SELECTED_SUBTOPIC } from '../../../modules/regions/regions.getters';
import { getRegionField } from '../../utils/helpers';

export default {
  components: { Container, TableBody },
  props: {
    dataSource: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters(REGIONS_STORE, [GET_SELECTED_SUBTOPIC, GET_SELECTED_FILTERS]),
    filters: function() {
      return this[GET_SELECTED_FILTERS];
    },
    titles() {
      const headers = pathOr([], ['tags', 'tableHeaders'], this[GET_SELECTED_SUBTOPIC]);

      return [getRegionField(this[GET_SELECTED_SUBTOPIC]), ...headers];
    },
    content() {
      const region = getRegionField(this[GET_SELECTED_SUBTOPIC]);

      return pipe(
        groupBy(prop(region)),
        toPairs,
        map(last),
        map(array => {
          array[0].highlighted = true;

          return array;
        }),
        flatten,
        sortBy(prop(region))
      )(this.dataSource);
    },
  },
};
</script>
